import lifeInsurance from './lifeInsurance';
import per from './per';

const types = { lifeInsurance, per };

export default types;
